<template>
  <div class="main col-xs-12">
    <AppMessages v-bind:message="this.message"
                 v-bind:type="this.messageType"
                 v-bind:show="this.show"/>

    <h1>Customer Exceptions</h1>

    <form>
      <div class="form-group form-group--half">
        <label class="label">Customer:</label>
        <selectize v-model="customer" :settings="customerSelectizeSettings">
          <option :value="customer.id" v-bind:key="customer.id" v-for="customer in customers" v-bind:data-sort-value="customer.name">{{ customer.name }}</option>
        </selectize>
      </div>

      <template v-if="customer">

        <div class="form-group">
          <label class="label">Cofa Email:</label>
          <textarea v-model="cofaemail" class="textarea"></textarea>
          <small>Separate multiple email addresses using the semicolon character</small>
        </div>

        <div class="form-group">
          <label class="label">SDS Email:</label>
          <textarea v-model="sdsemail" class="textarea"></textarea>
          <small>Separate multiple email addresses using the semicolon character</small>
        </div>

        <div class="form-group">
          <button class="button button--alt" type="button" @click="updateCustomerEmails">Update Emails</button>
        </div>
      </template>
    </form>

    <div v-show="customer">
      <label class="label">Product:</label>
      <AppProductSearch ref="child"  />
      <form>

        <div class="form-group form-group--half">
          <label class="label">Text 1</label>
          <input class="input form-block" v-model="newtext1" />
        </div>

        <div class="form-group form-group--half">
          <label class="label">Text 2</label>
          <input class="input form-block" v-model="newtext2" />
        </div>

        <div class="form-group form-group--half">
          <label class="label">Exceptions:</label>
          <selectize v-model="newaction">
            <option value="B">Both</option>
            <option value="S">Special</option>
          </selectize>
        </div>

        <div class="form-group">
          <button class="button button--alt" type="button" v-on:click="addException">Save</button>
        </div>
      </form>


      <table v-if="customerExceptions && customerExceptions.length > 0" class="table">
        <thead>
          <tr>
            <th></th>
            <th class="table__header">Product</th>
            <th class="table__header">Text 1</th>
            <th class="table__header">Text 2</th>
            <th class="table__header">Exceptions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-bind:key="customerException.productCode" v-for="customerException in customerExceptions">
            <td class="table__col">
              <a v-on:click="deleteException(customerException)" class="table__link">Delete</a>
            </td>
            <td class="table__col">{{ customerException.productCode }}</td>
            <td class="table__col">
              {{ customerException.text1 }}
            </td>
            <td class="table__col">
              {{ customerException.text2 }}
            </td>
            <td class="table__col">
              {{ customerException.action }}
            </td>
          </tr>
        </tbody>
      </table>

    </div>

  </div>


</template>

<script>
import Selectize from 'vue2-selectize';
import axios from 'axios';
import AppMessages from '@/components/AppMessages/AppMessages.vue';
import AppProductSearch from '@/components/AppProductSearch/AppProductSearch.vue';
import SearchObjects from '../mixins/SearchObjects';

export default {
  name: 'customerinfo',
  components: {
    Selectize,
    AppMessages,
    AppProductSearch
  },
  mixins: [SearchObjects],
  data() {
    return {
      selectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
      },
      customerSelectizeSettings: {
          maxOptions: 10000,
          sortField: [{ field: 'data-sort-value', direction: 'asc' }, { field: '$score' }],
          allowEmptyOption: false,
          placeholder: 'Select value'
      },
      customer: null,
      newproduct: null,
      newaction: null,
      newtext1: '',
      newtext2: '',
      cofaemail: '',
      sdsemail: '',
      message: '',
      messageType: '',
      customerExceptions: null,
      show: false,
    };
  },
  mounted() {
    this.$watch(
      '$refs.child.selectedProduct',
      (newValue, oldValue) => (this.newproduct = newValue.code)
    );
  },
  watch: {
    customer(value) {
      if (!value) {
        this.newtext1 = null;
        this.newtext2 = null;
        this.newproduct = null;
        this.newaction = null;
        return;
      }
      this.loadCustomer();
    },
  },
  computed: {
    customers() {
      return this.$store.state.customers;
    },
    products() {
      return this.$store.state.products;
    },
  },
  methods: {
    updateCustomerEmails() {
      const customerData = {
        cofaEmail: this.cofaemail ? this.cofaemail.split(';') : '',
        sdsEmail: this.sdsemail ? this.sdsemail.split(';') : '',
      };

      this.message = '';
      this.messageType = '';
      this.show = false;

      this.$Progress.start();
      const url = `/customers/${this.customer}`;
      axios.post(url, customerData)
        .then((r) => {
          this.$Progress.finish();
          this.message = 'Emails updated successfully';
          this.messageType = 'message message--success';
          this.show = true;
        })
        .catch((e) => {
          this.$Progress.fail();
          this.message = `Emails failed to update: ${e.response.data.join(', ')}`;
          this.messageType = 'message message--error';
          this.show = true;
        });
    },
    deleteException(exception) {
      // eslint-disable-next-line
        if (!window.confirm('Do you really want to delete?')) {
        return;
      }

      this.message = '';
      this.messageType = '';
      this.show = false;

      this.$Progress.start();

      const url = `/customers/${this.customer}/exceptions/${exception.productCode}`;
      axios.delete(url)
        .then(() => {
          this.message = 'Exception deleted successfully';
          this.messageType = 'message message--success';
          this.show = true;
        })
        .then(() => this.loadCustomer())
        .catch((e) => {
          this.message = `Exception not deleted: ${e.response.data.join(', ')}`;
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
    addException() {
      if (!this.customer) {
          this.message = 'Select a customer';
          this.messageType = 'message message--error';
          this.show = true;
        return;
      }

      this.$Progress.start();
      this.show = false;

      const url = `/customers/${this.customer}/exceptions`;
      axios.post(url, {
        productCode: this.newproduct,
        text1: this.newtext1,
        text2: this.newtext2,
        action: this.newaction,
      })
        .then(() => {
          this.message = 'Exception added successfully';
          this.messageType = 'message message--success';
          this.show = true;
          this.newproduct = null;
          this.newtext1 = '';
          this.newtext2 = '';
          this.newaction = null;
        })
        .then(() => this.loadCustomer())
        .catch((e) => {
          this.message = `Exception not added: ${e.response.data.join(', ')}`;
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
    loadCustomer() {
      const $scope = this;

      $scope.cofaemail = '';
      $scope.sdsemail = '';
      $scope.customerExceptions = null;

      if (!this.customer) { return; }

      this.$Progress.start();

      axios.all([axios.get(`/customers/${this.customer}`), axios.get(`/customers/${this.customer}/exceptions`)])
        .then(axios.spread((c, ce) => {
          $scope.cofaemail = c.data.cofaEmail.join(';');
          $scope.sdsemail = c.data.sdsEmail.join(';');
          $scope.customerExceptions = ce.data;
        }))
        .catch(() => {
          this.message = 'Customer details could not be loaded';
          this.messageType = 'message message--error';
          this.show = true;
          this.$Progress.fail();
        })
        .finally(() => {
          this.$Progress.finish();
        });
    },
  },
};
</script>
